import actions from './actions'

const initialState = {
  id: null,
  user: null,
  schedule: null,
}

export default function loggerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
